export default "__VITE_ASSET__CFx4PYw8__"